import { Box, useTheme } from '@mui/material';
import { Calendar, CalendarX } from 'lucide-react';
import React from 'react';

interface NewAvailabilityBadgeProps {
    availability: number | null;
    title?: string;
    size?: 'small' | 'medium';
}

export default function New_AvailabilityBadge({ availability, title, size = 'medium' }: NewAvailabilityBadgeProps) {
    const theme = useTheme();

    const isAvailable = availability !== null && availability > 0;
    const displayValue = availability !== null ? `${availability}%` : 'N/A';

    // Status-basierte Farben
    const getStatusColor = () => {
        if (!isAvailable) return theme.palette.grey[500];
        if (availability >= 80) return theme.palette.success.main;
        if (availability >= 50) return theme.palette.warning.main;
        return theme.palette.error.main;
    };

    const statusColor = getStatusColor();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                px: 1,
                py: 0.5,
                borderRadius: 1,
                bgcolor: statusColor,
                border: `1px solid ${statusColor}`,
                minWidth: size === 'small' ? 50 : 60,
                height: size === 'small' ? 20 : 24,
            }}
            title={title}
        >
            <Box sx={{ color: theme.palette.getContrastText(statusColor), display: 'flex' }}>
                {isAvailable ? (
                    <Calendar size={size === 'small' ? 12 : 14} />
                ) : (
                    <CalendarX size={size === 'small' ? 12 : 14} />
                )}
            </Box>
            <Box
                sx={{
                    fontSize: size === 'small' ? '0.7rem' : '0.75rem',
                    fontWeight: 600,
                    color: theme.palette.getContrastText(statusColor),
                    lineHeight: 1,
                }}
            >
                {displayValue}
            </Box>
        </Box>
    );
}
